import type { Patient } from './Patient';

export class PatientCollection {
  constructor(
    readonly patients: Patient[],
    readonly totalNumberOfPatients: number,
  ) {}
}
